//import Config from '../_config';
import Config from '../_config_liv';
import toast from 'react-hot-toast';

export const isIntersect = (a, b) => {
    return a.filter(o => {
        return b.includes(o);
    }).length > 0;
}

export const isSubset = (set, subset) => {
    return new Set([...set, ...subset]).size === set.length;
}

export const removeEmptyAttribute = (obj) => {
    return Object.entries(obj).reduce((a, [k, v]) => (v ? { ...a, [k]: v } : a), {})
}

const getAccessToken = () =>
    localStorage.getItem('access_token') || localStorage.getItem('token');

const attemptTokenRefresh = async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) return null;
    try {
        const resp = await fetch(Config.endpoint + 'refresh', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refresh_token: refreshToken }),
            credentials: 'include',
        });
        if (!resp.ok) return null;
        const data = await resp.json();
        if (data.body && data.body.access_token) {
            localStorage.setItem('access_token', data.body.access_token);
            if (data.body.refresh_token) {
                localStorage.setItem('refresh_token', data.body.refresh_token);
            }
            return data.body.access_token;
        }
    } catch (e) {}
    return null;
};

export const request = {
    "Fetch": async (method, url, body = undefined, handle_permission = true) => {
        method = method.toUpperCase();
        const bodyStr = ['GET'].includes(method) ? undefined : JSON.stringify(body);

        const doFetch = (accessToken) => fetch(Config.endpoint + url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'Accept': 'application/json'
            },
            body: bodyStr,
            credentials: 'include'
        });

        let res = await doFetch(getAccessToken());

        if ([401, 403].includes(res.status) && handle_permission) {
            const newToken = await attemptTokenRefresh();
            if (newToken) {
                res = await doFetch(newToken);
            }
        }

        if (handle_permission && [401, 403].includes(res.status)) {
            toast("Please Sign in to continue");
            window.location = '/registration?returnURL=' + window.location.href;
        }

        return res.json();
    },
    "GET": (url) => { return request.Fetch("GET", url) },
    "POST": (url, body) => { return request.Fetch("POST", url, body) },
    "PUT": (url, body) => { return request.Fetch("PUT", url, body) },
    "DELETE": (url) => { return request.Fetch("DELETE", url) },
}
